module.exports = __webpack_public_path__ + "static/media/Logo.33c1f514.png";